// Path: ./src/app/components/RenderImageTable/index.tsx
import React from "react";
import { Box, Grid } from "@mui/material";
import { GfImage } from "@swagger/typescript-fetch-goflyer";
import styled from "styled-components";

export function RenderImageTable({ src }: { src?: string }) {
  return (
    <Container data-testid="renderimagetable-test-id">
      {src ? <Image src={src} /> : <></>}
    </Container>
  );
}

export const RenderMultiImageTable = React.memo(
  ({ images }: { images?: GfImage[] }) => {
    return (
      <Grid
        container
        columns={3}
        rowSpacing={0}
        maxHeight={"100%"}
        height={"100%"}
        overflow={"hidden"}
        data-testid="rendermultiimagetable-test-id"
      >
        {images?.map((value, index) => (
          <Grid item xs={1} sm={1} md={1} key={index} sx={{ maxHeight: "100%" }}>
            <Box
              component="img"
              sx={{
                width: images?.length === 1 ? "60px" : "100%",
                height: images?.length === 1 ? "100%" : "auto",
                maxHeight: "100%",
                display: "block",
                objectFit: "contain",
                objectPosition: "center",
              }}
              alt={`Image ${index + 1}`}
              src={value?.srcSmall || value?.src}
            />
          </Grid>
        ))}
      </Grid>
    );
  },
  (prevProps, nextProps) => {
    if (!prevProps.images && !nextProps.images) return true;
    if (!prevProps.images || !nextProps.images) return false;
    if (prevProps.images.length !== nextProps.images.length) return false;

    return prevProps.images.every(
      (img, idx) =>
        img?.id === nextProps.images?.[idx]?.id &&
        (img?.srcSmall || img?.src) ===
          (nextProps.images?.[idx]?.srcSmall || nextProps.images?.[idx]?.src)
    );
  }
);

const Image = styled.img`
  width: 66px;
  height: 52px;
  object-fit: contain;
  object-position: center;
`;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
